import { getDomainBranding } from '../../tenant/tenantConfig.js';
import AnimatedTryggrLogo from './AnimatedTryggrLogo.jsx';

/**
 * App logo that adapts to the current domain branding.
 * SeaSuite → gradient box with "S"
 * Tryggr   → gradient box with the Tryggr rune SVG
 */
export default function AppLogo({ size = 52, borderRadius = 14, style = {}, src }) {
  const branding = getDomainBranding();
  const base = {
    width: size,
    height: size,
    borderRadius,
    background: 'linear-gradient(135deg, var(--accent), #38bdf8)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    ...style,
  };

  if (src) {
    return (
      <div style={{ ...base, background: 'transparent', padding: 0, overflow: 'hidden' }}>
        <img
          src={src}
          alt="Logo"
          draggable={false}
          style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius }}
        />
      </div>
    );
  }

  if (branding.name === 'Tryggr') {
    return <AnimatedTryggrLogo size={size} borderRadius={borderRadius} style={style} />;
  }

  if (branding.logoSvgPath) {
    return (
      <div style={base}>
        <svg
          width={size * 0.5}
          height={size * 0.5}
          viewBox={branding.logoViewBox}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d={branding.logoSvgPath} fill="#0d1f1e" />
        </svg>
      </div>
    );
  }

  return (
    <div
      style={{
        ...base,
        fontSize: Math.round(size * 0.42),
        fontWeight: 800,
        color: '#0d1f1e',
        fontFamily: 'var(--font-display)',
      }}
    >
      {branding.initial}
    </div>
  );
}
